import React, {useEffect} from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams
} from "react-router-dom";


import Menu from './components/menu';
import Footer from './components/footer';
import Home from './components/home';
import Profile from './components/profile/index';
import CausasAdd from './components/causas/add';
import CausasVer from './components/causas/ver';
import CausasEditar from './components/causas/editar';
import Causas from './components/causas';
import Politica from './components/politica';
import NoMatch from './components/404';
import PrivateRoute from './components/PrivateRoute'

import { UserProvider, useUser } from './context/UserContext'

import './styles/main.scss';

function Child() {
  // We can use the `useParams` hook here to access
  // the dynamic pieces of the URL.
  let { id } = useParams();

  return (
    <div>
      <h3>ID: {id}</h3>
    </div>
  );
}

const Bootstrap = () => {
  const { cargandoUsuario, setCargandoUsuario, usuario, setUsuario, setData, checkFBStatus } = useUser();
  useEffect( () => {

    window.fbSdkOnInit(() => {
        checkFBStatus();
    });

  }, []);

  return (<div />);
}

function App() {

  return (
    <Router>
      <UserProvider>
        <Bootstrap />
        
          <Menu />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/politica" component={Politica} />
            <Route exact path="/causas" component={Causas} />
            <PrivateRoute path="/causas/add" component={CausasAdd} />
            <Route path="/causa/editar/:id" component={CausasEditar} />
            <Route path="/causa/:id" component={CausasVer} />
            <PrivateRoute path="/mi-perfil" component={Profile} />
            <Route component={NoMatch} />
          </Switch>
          <Footer />
        
      </UserProvider>
      </Router>
  );
}

export default App;
